import { SxProps, Theme } from '@mui/material/styles';
import { AirshipIcon } from '../../icons';
import PublicImg from './PublicImg';

interface OrganizationLogoProps {
  logoParams: {
    organizationId?: string;
    organizationLogoUrlVersion?: string | null;
    imageProps?: {
      width: number;
    };
  };
  sx?: SxProps<Theme>;
  basePublicFilesUrl: string;
  fallbackIcon?: React.ReactNode;
}

const buildPath = (logoParams: OrganizationLogoProps['logoParams']) => {
  if (!logoParams.organizationId) {
    return undefined;
  }

  const { organizationId, organizationLogoUrlVersion } = logoParams;
  const path = [
    'transforms',
    'organization-logos',
    organizationId,
    'logo',
  ].join('/');

  const oneHour = 1 * 60 * 60 * 1000;
  const expiry = Math.ceil(Date.now() / oneHour) * oneHour;

  const params = new URLSearchParams({
    w: logoParams.imageProps?.width?.toString() || '200',
    fm: 'webp',
    v: organizationLogoUrlVersion || expiry.toString(),
  });

  return `/${path}?${params}`;
};

const OrganizationLogo: React.FC<OrganizationLogoProps> = ({
  logoParams,
  sx,
  basePublicFilesUrl,
  fallbackIcon,
}) => (
  <PublicImg
    src={buildPath(logoParams)}
    alt="Organization Logo"
    basePublicFilesUrl={basePublicFilesUrl}
    fallbackIcon={fallbackIcon ?? <AirshipIcon height="6.5rem" />}
    sx={{
      maxWidth: '100%',
      objectFit: 'contain',
      objectPosition: 'left',
      ...sx,
    }}
  />
);

export default OrganizationLogo;
